import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const zetaPotential = {
    jpath: ['spectra', 'zetaPotential'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default zetaPotential;
//# sourceMappingURL=zetaPotential.js.map